import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import CreateVideoModal from "../AiModule/CreateVideoModal";
import CreateAudienceModal from "../Ads/CreateAudienceModal";
import { toastify } from "../../components/Toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Users, ArrowLeft, Pencil, Trash2, Zap, Calendar, CheckCircle2, TrendingDown, FileText, Layers, Search } from "lucide-react";
import moment from "moment";



const AudienceDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [, setLoading] = useState(true);
  const [loadError, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [audience, setAudience] = useState("");

  // const audience = sampleAudiences.find((a) => a.id === id);

  useEffect(() => {
    // Refetch for this route/refresh only; discard the previous request on cleanup.
    const controller = new AbortController();
    let active = true;

    const token = localStorage.getItem("token");
    const fetchAudience = async () => {
      setLoading(true);
      setIsLoading(true);
      setError("");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}audiences/${id}`,
          { signal: controller.signal,
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        if (!active) return;
        if (!response?.data?.data || typeof response.data.data !== "object" || Array.isArray(response.data.data)) throw new Error("Missing detail data");
        setIsLoading(false);
        // setBrands(response.data.data);
        const audience = {
          id: response.data.data._id,
          title: response.data.data.name,
          description: response.data.data.description,
          icon: "Utensils",
          demographics:
            response.data.data.ageRange +
            " years • " +
            response.data.data.educationLevel,
          createdAt: response.data.data.createdAt,
          updatedAt: response.data.data.updatedAt,
          isActive: response.data.data.isActive,
          details: {
            ageRange: response.data.data.ageRange,
            location: response.data.data.location,
            income: response.data.data.incomeLevel,
            education: response.data.data.educationLevel,
            interests: Array.isArray(response.data.data.interests) ? response.data.data.interests : [],
            pinPointsAndChallenges:
              Array.isArray(response.data.data.pinPointsAndChallenges) ? response.data.data.pinPointsAndChallenges : [],
            preferredChannels: Array.isArray(response.data.data.preferredChannels) ? response.data.data.preferredChannels : [],
            contentPreferences: Array.isArray(response.data.data.contentPreferences) ? response.data.data.contentPreferences : [],
            // painPoints : response.data.data.pinPointsAndChallenges,
            goals: Array.isArray(response.data.data.goalsAndMotivations) ? response.data.data.goalsAndMotivations : [],
          },
          usageCount: 11,
          detailedDescription: response.data.data.description,
          interests: Array.isArray(response.data.data.interests) ? response.data.data.interests : [],
          pinPointsAndChallenges:
            Array.isArray(response.data.data.pinPointsAndChallenges) ? response.data.data.pinPointsAndChallenges : [],
          preferredChannels: Array.isArray(response.data.data.preferredChannels) ? response.data.data.preferredChannels : [],
          buyingBehavior:
            "Values authenticity, influenced by testimonials, prefers natural/organic products, research-driven",
          contentPreferences: Array.isArray(response.data.data.contentPreferences) ? response.data.data.contentPreferences : [],
        };

        setAudience(audience);
      } catch (err) {
        if (!active) return;
        setIsLoading(false);
        setError("Failed to load audience. Please try again.");
      } finally {
        if (active) {
        setIsLoading(false);
        setLoading(false);

        }
}
    };
    fetchAudience();

    return () => { active = false; controller.abort(); };
  }, [id, showEditModal]);

  const handleEditAudience = () => {
    setShowEditModal(true);
  };

  const handleSaveEditedAudience = (audienceData) => {
    setShowEditModal(false);
  };

  const handleCompetitorAnalysis = () => {
    navigate(`/app/audiences/${id}/competitors`);
  };

  const handleDeleteAudience = async () => {
    if (window.confirm("Are you sure you want to delete this audience?")) {
      const token = localStorage.getItem("token");
      // navigate("/app/audiences");
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API}audiences/${audience.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toastify("success", response.data.message);
        setTimeout(() => {
          navigate("/app/audiences");
        }, 1000);
      } catch (error) {
        console.error(error);
        toastify("error", error.response.data.message);
      }
    }
  };

  const getIconComponent = (iconName) => {
    const iconMap = {
      Briefcase: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0H8m8 0v2a2 2 0 01-2 2H10a2 2 0 01-2-2V6m8 0v2a2 2 0 01-2 2H10a2 2 0 01-2-2V6"
          />
        </svg>
      ),
      GraduationCap: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 14l9-5-9-5-9 5 9 5z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
          />
        </svg>
      ),
      Heart: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      ),
      Gamepad2: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
          />
        </svg>
      ),
      Palette: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z"
          />
        </svg>
      ),
      Utensils: (
        <svg
          className="w-8 h-8 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"
          />
        </svg>
      ),
    };
    return iconMap[iconName] || iconMap.Briefcase;
  };

  if (loadError) return <div role="alert">{loadError}</div>;
  if (!audience) {
    return (
      <>
        {isLoading ? (
          <div className="App-loading">
            <div className="App-logo" title="Zimzee" />
          </div>
        ) : (
          <div className="flex-1 overflow-auto bg-white">
            <div className="p-6">
              <div className="text-center py-12">
                <Users className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Audience not found
                </h3>
                <p className="text-gray-600 mb-4">
                  The audience you're looking for doesn't exist.
                </p>
                <button
                  onClick={() => navigate("/app/audiences")}
                  className="border border-gray-300 text-gray-700 hover:bg-gray-50 px-4 py-2 rounded-lg flex items-center gap-2 mx-auto"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Back to Audiences
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="responsive-page responsive-page--audience-detail flex-1 overflow-auto bg-white dark:bg-[#0A0A0A]">
          <div className="p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => navigate("/app/audiences")}
                  className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff] flex items-center gap-2"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Back to Audiences
                </button>
              </div>
              <div className="flex items-center space-x-3">
                <button
                  onClick={handleEditAudience}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 px-4 py-2 rounded-lg flex items-center gap-2"
                >
                  <Pencil className="w-4 h-4" />
                  Edit
                </button>
                <button
                  onClick={handleDeleteAudience}
                  className="border border-gray-300 dark:border-gray-600 text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 px-4 py-2 rounded-lg flex items-center gap-2"
                >
                  <Trash2 className="w-4 h-4" />
                  Delete
                </button>
                <button
                  onClick={() => setShowGenerateModal(true)}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hidden"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                  Generate Content
                </button>
              </div>
            </div>

            {/* Audience Header Card */}
            <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6 mb-6">
              <div className="audience-summary grid grid-cols-[56px_minmax(0,1fr)] gap-x-3 gap-y-4 sm:grid-cols-[64px_minmax(0,1fr)] sm:gap-x-4">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
                  {getIconComponent(audience.icon)}
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                    <h1 className="audience-summary__title w-full min-w-0 text-xl leading-tight font-bold text-gray-900 dark:text-[#fff] sm:w-auto sm:text-2xl">
                      {audience.title}
                    </h1>
                    <span className="audience-summary__badge max-w-full bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 px-2 py-1 rounded text-sm">
                      {audience.demographics}
                    </span>
                    <span
                      className={`audience-summary__badge audience-summary__status rounded px-2 py-1 text-sm ${
                        audience.isActive
                          ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
                          : "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
                      }`}
                    >
                      {audience.isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
                <div className="col-span-2 min-w-0 sm:col-span-1 sm:col-start-2">
                  <p className="text-gray-600 dark:text-gray-400 mb-4">
                    {audience.detailedDescription}
                  </p>
                  <div className="flex flex-col items-start gap-2 text-sm text-gray-500 dark:text-gray-400 sm:flex-row sm:flex-wrap sm:gap-x-6">
                    <div className="flex min-w-0 items-start gap-1">
                      <Calendar className="mt-0.5 h-4 w-4 flex-none" />
                      <span>
                        Created{" "}
                        {moment(audience?.createdAt).format("MMM D, YYYY")}
                      </span>
                    </div>
                    <div className="flex min-w-0 items-start gap-1">
                      <Calendar className="mt-0.5 h-4 w-4 flex-none" />
                      <span>
                        Updated{" "}
                        {moment(
                          audience?.updatedAt || audience?.createdAt
                        ).format("MMM D, YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Demographics */}
            <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff] mb-4">
                Demographics
              </h3>
              <dl className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                <div>
                  <dt className="text-gray-500 dark:text-gray-400">Age range</dt>
                  <dd className="mt-1 font-medium text-gray-900 dark:text-white">
                    {audience.details.ageRange
                      ? `${audience.details.ageRange} years`
                      : "Not specified"}
                  </dd>
                </div>
                <div>
                  <dt className="text-gray-500 dark:text-gray-400">Location</dt>
                  <dd className="mt-1 font-medium text-gray-900 dark:text-white">
                    {audience.details.location || "Not specified"}
                  </dd>
                </div>
                <div>
                  <dt className="text-gray-500 dark:text-gray-400">Income level</dt>
                  <dd className="mt-1 font-medium capitalize text-gray-900 dark:text-white">
                    {audience.details.income || "Not specified"}
                  </dd>
                </div>
                <div>
                  <dt className="text-gray-500 dark:text-gray-400">Education</dt>
                  <dd className="mt-1 font-medium capitalize text-gray-900 dark:text-white">
                    {audience.details.education || "Not specified"}
                  </dd>
                </div>
              </dl>
            </div>

            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Interests */}
              <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
                <div className="flex items-center space-x-2 mb-4">
                  <CheckCircle2 className="w-5 h-5 text-orange-500" />
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff]">
                    Interests
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {audience.interests.map((interest, index) => (
                    <span
                      key={index}
                      className="bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800 px-2 py-1 rounded text-sm"
                    >
                      {interest}
                    </span>
                  ))}
                </div>
              </div>

              {/* Pain Points */}
              {audience.pinPointsAndChallenges.length ? (
                <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
                  <div className="flex items-center space-x-2 mb-4">
                    <TrendingDown className="w-5 h-5 text-red-500" />
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff]">
                      Pain Points
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {audience.pinPointsAndChallenges.map((painPoint, index) => (
                      <span
                        key={index}
                        className="bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800 px-2 py-1 rounded text-sm"
                      >
                        {painPoint}
                      </span>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* Goals and Motivations */}
              {audience.details.goals.length ? (
                <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
                  <div className="flex items-center space-x-2 mb-4">
                    <CheckCircle2 className="w-5 h-5 text-orange-500" />
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff]">
                      Goals &amp; Motivations
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {audience.details.goals.map((goal, index) => (
                      <span
                        key={index}
                        className="bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800 px-2 py-1 rounded text-sm"
                      >
                        {goal}
                      </span>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* Preferred Channels */}
              {audience.preferredChannels.length ? (
                <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
                  <div className="flex items-center space-x-2 mb-4">
                    <svg
                      className="w-5 h-5 text-green-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                      />
                    </svg>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff]">
                      Preferred Channels
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {audience.preferredChannels.map((channel, index) => (
                      <span
                        key={index}
                        className="bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800 px-2 py-1 rounded text-sm"
                      >
                        {channel}
                      </span>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* Content Preferences */}
              {audience.contentPreferences.length ? (
                <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
                  <div className="flex items-center space-x-2 mb-4">
                    <FileText className="w-5 h-5 text-purple-500" />
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff]">
                      Content Preferences
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {audience.contentPreferences.map((preference, index) => (
                      <span
                        key={index}
                        className="bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800 px-2 py-1 rounded text-sm"
                      >
                        {preference}
                      </span>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* Quick Actions */}
            <div className="bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-6 mt-6 hidden">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-[#fff] mb-4">
                Quick Actions
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <button className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 px-4 py-2 rounded-lg flex items-center gap-2 justify-start">
                  <Layers className="w-4 h-4" />
                  Duplicate Audience
                </button>
                <button
                  onClick={handleCompetitorAnalysis}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 px-4 py-2 rounded-lg flex items-center gap-2 justify-start"
                >
                  <Search className="w-4 h-4" />
                  Competitor Analysis
                </button>
                <button
                  onClick={() => setShowGenerateModal(true)}
                  className="hidden bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 justify-start"
                >
                  <Zap className="w-4 h-4" />
                  Generate Content for this Audience
                </button>
              </div>
            </div>
          </div>
          <ToastContainer />
          {/* Generate Content Modal */}
          <CreateVideoModal
            open={showGenerateModal}
            onOpenChange={setShowGenerateModal}
            selectedBrandId=""
            selectedBrandName=""
            selectedAudienceId={audience.id}
            selectedAudienceName={audience.title}
          />

          {/* Edit Audience Modal */}
          <CreateAudienceModal
            open={showEditModal}
            onOpenChange={setShowEditModal}
            onSave={handleSaveEditedAudience}
            editingAudience={audience}
          />
        </div>
      )}
    </>
  );
};

export default AudienceDetail;
